<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <!--<button class="btn btn-success pull-right" @click="addAnalog">Қўшиш</button>-->
                        <!--<div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">-->
                            <!--1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})-->
                        <!--</div>-->
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                              <div class="table-wrapper">
                                <table class="table table-striped comparison-table" style="min-width: 900px">
                                    <tr>
                                        <th rowspan="2" class="w-10 text-center">Т/р</th>
                                        <th rowspan="2" class="w-25 text-center">Тарихий кўрсаткич номи</th>
                                        <th :colspan="3" class="text-center">
                                            Тарихий ўзгаришлар
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" v-for="(analog, index) in financeResult.periods" :key="index" style="position: relative" >
                                            <table class="w-100">
                                                <tr>
                                                    <th colspan="2" class="border-0">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                {{analog.label}}
                                                            </div>
                                                            <div class="col-12">
                                                                <custom-date-picker
                                                                        class="form-control"
                                                                        :format="'dd/MM/yyyy'"
                                                                        v-model="analog.date"
                                                                        :date="analog.date"
                                                                        :clear-button="true">
                                                                </custom-date-picker>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">1</td>
                                        <td class="w-25 text-center">Таъсис этилган сана 20.01.2019</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['foundingDate'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">2</td>
                                        <td class="w-25 text-center">Узоқ муддатли активлар (Ф1-130-сатр</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['longTermAssets'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">3</td>
                                        <td class="w-25 text-center">Жорий активлар (Ф1-390-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['currentAssets'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">4</td>
                                        <td class="w-25 text-center">Ўз маблағлари манбалари (Ф1-480-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['sourcesOfOwnFunds'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">5</td>
                                        <td class="w-25 text-center">Мажбуриятлар (Ф1-770-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['obligations'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">6</td>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишдан соф тушум (Ф2-010-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['netProceedsSaleProducts'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">7</td>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишнинг ялпи фойдаси (зарари) (Ф2-030-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['grossProfitOrLossProductSales'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">8</td>
                                        <td class="w-25 text-center">Давр харажатлари, жами  (Ф2-040-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['totalPeriodCosts'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">9</td>
                                        <td class="w-25 text-center">Асосий фаолиятнинг фойдаси (зарари) (Ф2-100-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['profitOrLossMainActivity'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">10</td>
                                        <td class="w-25 text-center">Молиявий фаолиятнинг даромадлари, жами (Ф2-110-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['totalFinancialIncome'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">11</td>
                                        <td class="w-25 text-center">Молиявий фаолият бўйича харажатлар, (Ф2-170-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['financialActivityCosts'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">12</td>
                                        <td class="w-25 text-center">Умумхўжалик фаолиятининг фойдаси (зарари), (Ф2-220-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['profitOrLossEconomicActivity'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">13</td>
                                        <td class="w-25 text-center">Фойда солиғини тўлагунга қадар фойда (зарар), (Ф2-240-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['profitOrLossBeforeIncomeTaxPayment'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-10 text-center">14</td>
                                        <td class="w-25 text-center">Ҳисобот даврининг соф фойдаси (зарари), (Ф2-270-сатр)</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['netProfitOrLossReportingPeriod'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                              </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker';
   // import Treeselect from '@riophae/vue-treeselect';
   //  import {formatDate/*, parseDate*/} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    // import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';

    export default {
        name: "BusinessEntityHistoryView",
        components: {
            CustomDatePicker
           // Treeselect
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                businessId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                name: '',
                region: null,
                financeResult: {
                    'foundingDate': this.fillData('foundingDate'),
                    'longTermAssets': this.fillData('longTermAssets'),
                    'currentAssets': this.fillData('currentAssets'),
                    'sourcesOfOwnFunds': this.fillData('sourcesOfOwnFunds'),
                    'obligations': this.fillData('obligations'),
                    'netProceedsSaleProducts': this.fillData('netProceedsSaleProducts'),
                    'grossProfitOrLossProductSales': this.fillData('grossProfitOrLossProductSales'),
                    'totalPeriodCosts': this.fillData('totalPeriodCosts'),
                    'profitOrLossMainActivity': this.fillData('profitOrLossMainActivity'),
                    'totalFinancialIncome': this.fillData('totalFinancialIncome'),
                    'financialActivityCosts': this.fillData('financialActivityCosts'),
                    'profitOrLossEconomicActivity': this.fillData('profitOrLossEconomicActivity'),
                    'profitOrLossBeforeIncomeTaxPayment': this.fillData('profitOrLossBeforeIncomeTaxPayment'),
                    'netProfitOrLossReportingPeriod': this.fillData('netProfitOrLossReportingPeriod'),
                    businessId: this.businessId,
                    periods: [
                        {
                            date: null,
                            label: 'охирги ҳисобот санасига'
                        },
                        {
                            date: null,
                            label: 'охирги бир йиллик ҳисобот'
                        },
                        {
                            date: null,
                            label: 'охирги уч йиллик ҳисобот'
                        }
                    ],
                    data: {

                    }
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                createDate: null,
                sectionResId: null,
                sectionType: null,
                maxMadeYear: new Date().getFullYear()
            }
        },
        validations() {
            return {
            }
        },
        computed: {
            // calculated() {
            //
            // },
        },
        methods: {
            fillData(key) {
                return {
                    code: key,
                    years: [
                        {
                            value: 0
                        },
                        {
                            value: 0
                        },
                        {
                            value: 0
                        }
                    ]
                };
            },
            init() {
                const vm = this;
                this.$http.get('asset/business-entity-history/' + this.businessId)
                    .then(res => {
                        if (res.data) {
                            for (const key in res.data.data) {
                                vm.financeResult[key].years = res.data.data[key];
                            }
                            if (res.data.periods) {
                                vm.financeResult.periods = res.data.periods;
                            }
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'business/edit/' + this.businessId);
            },
            save() {
                // this.$v.$touch();
                // if (this.$v.$invalid) {
                //     return;
                // }
                this.financeResult.businessId = this.businessId;
                var years_columns = [];
                this.financeResult.periods.forEach((field) => {
                    years_columns.push({
                        date: field.date,
                        label: field.label
                    });
                });
                this.financeResult.periods = years_columns;
                for (let key in this.financeResult) {
                    if (!(key === "businessId" || key === "periods" || key === "data")) {
                        this.financeResult.data[key] = this.financeResult[key].years;
                    }
                }
                console.log(this.financeResult);
                this.processing = true;
                this.$http.post('asset/save-business-entity-history', this.financeResult)
                    .then(res => {
                        console.log(res.data);
                        if (res && res.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('business.financeResult.success'),
                                type: 'success'
                            });
                            this.$router.push(this.parentName + 'business/edit/' + this.businessId);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
